// A slider scale's `captions` column is capped at 7 (RatingScale.captions ArrayField size=7);
// rating / radio-ranking columns allow more, so labels carried into a slider must be truncated.
const MAX_SLIDER_CAPTIONS = 7;

// Build rating / radio-ranking column definitions from labels. `value` is the 1..N column position;
// `analysis_value` ("Values for reporting") is deliberately NOT set here - callers supply it.
function valuesFromColumnLabels(labels) {
  return labels.map(function (label, i) {
    return { 'value_name': label || '', 'value': i + 1 };
  });
}

app.service('scaleService', ['HttpAuth', 'portalHelper', 'apiHelper', '$q', 'CONSTANTS',
  function (HttpAuth, portalHelper, apiHelper, $q, CONSTANTS) {
    this.numberOfColumnsChanged = function (scale) {
      scale.columnWidth = (96 / scale.numberOfColumns).toFixed() + '%';

      const diff = scale.numberOfColumns - scale.values.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          scale.values[scale.values.length] = { 'value_name': '', 'value': i + 1 };
        }
      } else if (diff < 0) {
        for (let i = diff; i < 0; i++) {
          scale.values.pop();
        }
      }

      // Recalculating the scale value positions
      for (let i = 0; i < scale.numberOfColumns; i++) {
        scale.values[i].value = i + 1;
      }
    };

    this.removeScaleValue = function (scale, index) {
      if (scale.values.length === 1) {
        return;
      }

      scale.values.splice(index, 1);
      scale.numberOfColumns = scale.values.length;
      this.numberOfColumnsChanged(scale);
    };

    this.validate = function (scale, error_list) {
      let res = true;
      error_list = [];

      const rankingTypes = [CONSTANTS.scaleTypes.RANKING, CONSTANTS.scaleTypes.RADIO_RANKING];
      const scalesTwoValues = [
        CONSTANTS.scaleTypes.RATING,
        CONSTANTS.scaleTypes.RANKING,
        CONSTANTS.scaleTypes.SLIDER_RATING_SCALE,
        CONSTANTS.scaleTypes.RADIO_RANKING
      ];

      if (!scale.name) {
        error_list.push('Please enter a scale name');
        res = false;
      }

      if (scalesTwoValues.indexOf(scale.scale_type) > -1 &&
        scale.values.length < 2
      ) {
        error_list.push('Please enter at least 2 scale values');
        res = false;
      }

      if (scale.scale_type === portalHelper.scaleTypeIds.RANKING) {
        // Ranking Scale - must have at least 2 options to order
        if (scale.options.length < 2) {
          error_list.push('Please enter at least 2 options to rank');
          res = false;
        }

        // items_to_rank should be between 1 and max length
        const itemsToRank = scale.items_to_rank;
        if (itemsToRank !== null && (itemsToRank < 1 || itemsToRank > scale.options.length)) {
          res = false;
          error_list.push('Please enter a number between 1 and ' + scale.options.length +
            ' in the No. of items to rate field.');
        }
      }

      if (scale.scale_type === portalHelper.scaleTypeIds.SLIDER_RATING) {
        if (_.uniq(scale.captions).length !== scale.captions.length) {
          res = false;
          error_list.push('Please remove duplicate column labels');
        }

        // captions should have non null values
        if (_.contains(scale.captions, null) || _.contains(scale.captions, '') || _.contains(scale.captions, undefined)) {
          res = false;
          error_list.push('Column labels should not have empty values. Remove empty labels if required.');
        }
      }

      if (scale.options && scale.options.length > 0) {
        for (let i = 0; i < scale.options.length; i++) {
          if (!scale.options[i].option_name[0] || scale.options[i].option_name[0].trim() == '') {
            res = false;
            error_list.push('Scale options can\'t be blank');
            break;
          }
        }
      }

      return { 'valid': res, 'error_list': error_list };
    };

    /**
     *
     * @param {*} response - The response to be saved
     * @param {*} questions - The list of questions
     * @description This function will map the slider rating value to the scale id.
     * This is needed because the slider rating scale value is the value of the scale, not the id. When we save the response, we need to save the id of the scale.
     */

    this.mapSliderValueToScaleId = function(response, questions) {
      const question = questions.find(question => question.id == response.question);
      if (question.type === CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE) {
        //  If the question is a slider rating scale, we need to map the value to the scale id.
        response.rating_responses.forEach(function (ratingResponse) {
          if (!ratingResponse.non_discrete_scale_value) {
            const scale = question.scale.values.find(val => val.value == ratingResponse.value);
            if (scale) {
              ratingResponse.value = scale.id;
            }
          }
          ratingResponse.value_name = '';
        });

        if (response.payer_value !== null) {
          const scale = question.scale.values.find(val => val.value == response.payer_value);
          if (scale) { response.payer_value = scale.id; }
        }
      }
    };


    //  This function will clean the scale data to be saved based on the scale type.
    //  When we change the question type, some data from another question type is kept for interchanging between question types.
    //  While saving we ned to clean all unnecessary fields, this is what this function achieves.
    this.scaleDataCleaner = function(questionType, scaleData){

      // Per-column min-chars only apply to Rating / Radio Ranking. Strip stale values (and the
      // UI-only enabled flags) on any other type so a scale-type conversion doesn't 400 server-side.
      const perColumnMinCharsSupported = [
        CONSTANTS.questionTypeIds.RATING,
        CONSTANTS.questionTypeIds.RADIO_RANKING
      ].includes(questionType);
      if (!perColumnMinCharsSupported) {
        delete scaleData.rationale_min_chars;
        delete scaleData.rationale_min_chars_enabled;
      }

      switch (questionType){
        case CONSTANTS.questionTypeIds.RATING:
          scaleData.options = _.map(scaleData.options, function(option) {
            return option;
          });

          delete scaleData.items_to_rank;
          delete scaleData.heading_columns;

          return scaleData;

        case CONSTANTS.questionTypeIds.DRAG_DROP_RANKING:
          scaleData.options = _.map(scaleData.options, function(option) {
            option.option_name = [option.option_name[0]];
            return option;
          });

          delete scaleData.description;
          delete scaleData.heading_rows;
          delete scaleData.heading_columns;

          return scaleData;

        case CONSTANTS.questionTypeIds.RADIO_RANKING:
          scaleData.options = _.map(scaleData.options, function(option) {
            option.option_name = [option.option_name[0]];
            return option;
          });

          delete scaleData.description;

          if (Array.isArray(scaleData.heading_rows) && scaleData.heading_rows.length > 1) {
            scaleData.heading_rows = [scaleData.heading_rows[0]];
          }

          if (Array.isArray(scaleData.heading_columns) && scaleData.heading_columns.length > 1) {
            scaleData.heading_columns = [scaleData.heading_columns[0]];
          }

          return scaleData;

        default:
          return scaleData;
      }
    };


    // Fields that belong to a single scale family only. When a question's type changes between
    // scale families the previous type's fields must be dropped, otherwise the API rejects the
    // scale - e.g. a rating/ranking scale carrying leftover slider `captions` fails validation
    // with `captions: ["This field is not expected"]` (RPR-5385), and leftover `items_to_rank` is
    // rejected on non-ranking scales.
    const SLIDER_ONLY_SCALE_FIELDS = ['captions', 'snap_to_discrete', 'decimal_places'];
    const RANKING_ONLY_SCALE_FIELDS = ['items_to_rank'];

    const stripForeignScaleFields = function (scale, targetScaleType) {
      if (targetScaleType !== CONSTANTS.scaleTypes.SLIDER_RATING) {
        SLIDER_ONLY_SCALE_FIELDS.forEach(function (field) { delete scale[field]; });
      }
      if (targetScaleType !== CONSTANTS.scaleTypes.RANKING && targetScaleType !== CONSTANTS.scaleTypes.RADIO_RANKING) {
        RANKING_ONLY_SCALE_FIELDS.forEach(function (field) { delete scale[field]; });
      }
    };

    // Scale types that expose per-column labels: rating and radio-button ranking keep them in
    // values[].value_name; a slider keeps them in captions. (Drag-and-drop ranking has no columns.)
    const columnLabelScaleTypes = new Set([
      CONSTANTS.scaleTypes.RATING,
      CONSTANTS.scaleTypes.RADIO_RANKING,
      CONSTANTS.scaleTypes.SLIDER_RATING
    ]);

    const initiate_scale = function ($scope) {
      let scale = $scope.cur_question.scale;

      // scale_type this scale had before the (possible) question-type change. A change between
      // scale families means the previous type's values/options are structurally incompatible and
      // must be rebuilt, not carried over (RPR-5385 slider<->rating, RPR-6352 slider->ranking where
      // the 11 slider values otherwise surface as ranking columns). On a plain edit (no type change)
      // previousScaleType matches the target, so nothing below is reset and the scale is preserved.
      // This relies on the scale-loading path (loadScale) populating a saved scale's persisted
      // scale_type before initiate_scale runs; if that ever changes, revisit this detection.
      const previousScaleType = scale?.scale_type;
      const switchedTo = function (targetScaleType) {
        return previousScaleType !== undefined && previousScaleType !== targetScaleType;
      };

      // Column labels from the previous scale, captured before we rebuild anything. Rating shows
      // these as value names ("Values to show Payers"); a Slider shows the same labels as its
      // `captions`. Carrying them across a slider<->rating switch preserves the labels the user
      // entered (RPR-5385: no data loss). The structurally-incompatible parts (a slider's 0-100
      // grid values, a rating scale's reporting values) are still rebuilt below.
      const previousCaptions = scale && Array.isArray(scale.captions) ? scale.captions.slice() : null;
      const previousValueNames =
        scale && Array.isArray(scale.values) ? scale.values.map(function (v) { return v.value_name; }) : null;

      // The column labels the user typed, read from wherever the previous scale type kept them.
      // Applied to the target type's own column-label field below so a switch between any two
      // column-bearing scale types keeps the labels (RPR-5385 slider<->rating, RPR-6352
      // slider->radio ranking). null when the previous type had no column labels (drag-and-drop
      // ranking, or a non-scale question type).
      let previousColumnLabels = null;
      if (previousScaleType === CONSTANTS.scaleTypes.SLIDER_RATING) {
        previousColumnLabels = previousCaptions;
      } else if (columnLabelScaleTypes.has(previousScaleType)) {
        previousColumnLabels = previousValueNames;
      }
      // Only treat the previous labels as worth carrying if at least one is non-blank - a slider's
      // default captions are an array of undefined/null, which would otherwise carry over as empty
      // columns.
      const hasPreviousColumnLabels = !!previousColumnLabels?.some(function (label) {
        return label != null && String(label).trim() !== '';
      });

      switch ($scope.cur_question.type) {
        case $scope.questionTypeIds.RADIO_RANKING: {
          const switched = switchedTo(CONSTANTS.scaleTypes.RADIO_RANKING);
          if (!scale) {
            scale = {
              'scale_type': CONSTANTS.scaleTypes.RADIO_RANKING,
              'heading_rows': []
            };
          } else {
            scale.scale_type = CONSTANTS.scaleTypes.RADIO_RANKING;
          }

          // Rebuild the rating columns only when the previous values are structurally incompatible.
          // Rating and radio-ranking store columns identically (1..N value + value_name + the
          // analysis_value / percentage_width / rationale fields), so keep the whole value objects
          // when switching between them - rebuilding from labels alone would silently drop the
          // reporting values and widths. Only a slider's 0-100 grid doesn't map (keep just its
          // labels), and an empty/absent set falls back to three blank columns. (Ranked row items
          // are handled separately, from question.options, in question_type_change_step2.)
          if (previousScaleType === CONSTANTS.scaleTypes.SLIDER_RATING) {
            scale.values = hasPreviousColumnLabels
              ? valuesFromColumnLabels(previousColumnLabels)
              : valuesFromColumnLabels(['', '', '']);
          } else if (!scale.values?.length) {
            scale.values = valuesFromColumnLabels(['', '', '']);
          }

          // Only reset the ranked items when there are none to keep. Switching in from the other
          // ranking type (drag-and-drop) preserves them - both store items in scale.options;
          // rating/slider have no scale.options and fall through to the step2 option mapping. Do
          // NOT gate this on `switched` (that discarded the items on a ranking<->ranking switch).
          if (!scale.options || scale.options.length === 0) {
            scale.options = [{ 'option_name': [''] }, { 'option_name': [''] }, { 'option_name': [''] }];
          }

          // Reset number of Columns to match the (possibly rebuilt) values
          if (switched || !scale.numberOfColumns) {
            scale.numberOfColumns = scale.values.length;
            scale.columnWidth = (96 / scale.numberOfColumns).toFixed() + '%';
          }

          stripForeignScaleFields(scale, CONSTANTS.scaleTypes.RADIO_RANKING);
          $scope.cur_question.scale = scale;
          break;
        }

        case $scope.questionTypeIds.DRAG_DROP_RANKING: {
          // Stale values from a previous scale type are safe here: save_rating_scale rebuilds them
          // from scale.options for drag-drop before saving. (No column labels to carry either.)
          if (!scale) {
            scale = {
              'scale_type': CONSTANTS.scaleTypes.RANKING
            };
          } else {
            scale.scale_type = CONSTANTS.scaleTypes.RANKING;
          }

          // Only reset the ranked items when there are none to keep. Switching in from the other
          // ranking type (radio-button ranking) preserves them - both store items in scale.options.
          if (!scale.options || scale.options.length === 0) {
            scale.options = [{ 'option_name': [''] }, { 'option_name': [''] }, { 'option_name': [''] }];
          }
          // items_to_rank tracks how many options must be ranked; clamp it to the option count when
          // unset or out of range, but keep a deliberate smaller value (e.g. "rank 3 of 5").
          if (!scale.items_to_rank || Number(scale.items_to_rank) > scale.options.length) {
            scale.items_to_rank = scale.options.length.toString();
          }

          stripForeignScaleFields(scale, CONSTANTS.scaleTypes.RANKING);
          $scope.cur_question.scale = scale;
          break;
        }

        case $scope.questionTypeIds.RATING: {
          const switched = switchedTo(CONSTANTS.scaleTypes.RATING);
          if (!scale) {
            scale = {
              'scale_type': CONSTANTS.scaleTypes.RATING
            };
          } else {
            scale.scale_type = CONSTANTS.scaleTypes.RATING;
          }

          // Rebuild the value columns only when the previous values are structurally incompatible.
          // Rating and radio-ranking store columns identically, so keep the whole value objects when
          // switching between them (preserving analysis_value / percentage_width). Only a slider's
          // 0-100 grid doesn't map - keep just its labels; an empty/absent set falls back to blanks.
          if (previousScaleType === CONSTANTS.scaleTypes.SLIDER_RATING) {
            scale.values = hasPreviousColumnLabels
              ? valuesFromColumnLabels(previousColumnLabels)
              : valuesFromColumnLabels(['', '', '']);
          } else if (!scale.values?.length) {
            scale.values = valuesFromColumnLabels(['', '', '']);
          }

          // Reset number of Columns to match the (possibly rebuilt) values
          if (switched || !scale.numberOfColumns) {
            scale.numberOfColumns = scale.values.length;
            scale.columnWidth = (96 / scale.numberOfColumns).toFixed() + '%';
          }

          stripForeignScaleFields(scale, CONSTANTS.scaleTypes.RATING);
          $scope.cur_question.scale = scale;
          break;
        }

        case $scope.questionTypeIds.SLIDER_RATING_SCALE: {
          const switched = switchedTo(CONSTANTS.scaleTypes.SLIDER_RATING);
          // Carry the previous type's column labels over as the slider's column captions when
          // switching in (RPR-5385 rating -> slider) so the labels are not lost. Cap at
          // MAX_SLIDER_CAPTIONS - a slider's `captions` array is limited to 7 server-side, while a
          // rating / radio-ranking source may have up to 11 columns; carrying more 400s the save.
          const sliderCaptions = hasPreviousColumnLabels
            ? previousColumnLabels.slice(0, MAX_SLIDER_CAPTIONS)
            : null;
          if (!scale) {
            // No prior scale (new question, or coming from a non-scale type) - there are no labels
            // to carry here, so start with blank captions.
            scale = {
              'scale_type': CONSTANTS.scaleTypes.SLIDER_RATING,
              'snap_to_discrete': true,
              'captions': new Array(3).fill(undefined),
              'decimal_places': 0
            };
          } else {
            scale.scale_type = CONSTANTS.scaleTypes.SLIDER_RATING;
            // Slider scales require these fields; (re)initialise them when converting in from
            // another scale type that does not carry them (RPR-5385 rating -> slider).
            if (switched || scale.snap_to_discrete === undefined || scale.snap_to_discrete === null) {
              scale.snap_to_discrete = true;
            }
            if (switched || scale.decimal_places === undefined || scale.decimal_places === null) {
              scale.decimal_places = 0;
            }
            if (switched) {
              scale.captions = sliderCaptions || new Array(3).fill(undefined);
            } else if (!scale.captions) {
              scale.captions = new Array(3).fill(undefined);
            }
          }

          // Slider value names must be blank and evenly spaced; rebuild them when switching in from
          // another scale type so we don't carry named/duplicate values that the API rejects.
          if (switched || !scale.values || scale.values.length === 0) {
            scale.values = new Array(11).fill().map((_, i) => {
              return { 'value_name': '', 'value': i*10 };
            });
          }

          stripForeignScaleFields(scale, CONSTANTS.scaleTypes.SLIDER_RATING);
          $scope.cur_question.scale = scale;
          break;
        }
      }

      if ($scope.cur_question.rating_scale) {
        $scope.cur_question.scale.id = null;
      }
    };

    this.loadScale = function ($scope) {
      if ($scope.cur_question.rating_scale) {
        const url = apiHelper.getApiUrl() + '/api/authoring/scale/' + $scope.cur_question.rating_scale + '.json';

        return HttpAuth.get(url).then(
          function (result) {
            $scope.cur_question.scale = result.data;
            $scope.cur_question.originalScaleType = $scope.cur_question.scale.scale_type;
            $scope.cur_question.scale.numberOfColumns = $scope.cur_question.scale.values.length;
            $scope.cur_question.scale.columnWidth = (96 / $scope.cur_question.scale.numberOfColumns).toFixed() + '%';
            if ($scope.cur_question.scale.options) {
              $scope.cur_question.scale.options = portalHelper.convertScaleOptionsFromResponse($scope.cur_question.type, $scope.cur_question.scale.options);
            }
            // use more_info_columns_count to set numberOfMoreInfoColumns, default to 1 if not set for existing scales
            // default null value was causing issues in the UI
            $scope.cur_question.scale.numberOfMoreInfoColumns = $scope.cur_question.scale.more_info_columns_count || 1;
            if (!$scope.cur_question.scale.more_info_column_widths) {
              $scope.cur_question.scale.more_info_column_widths = [];
            } else if (!Array.isArray($scope.cur_question.scale.more_info_column_widths)) {
              const count = $scope.cur_question.scale.more_info_columns_count || Object.keys($scope.cur_question.scale.more_info_column_widths).length;
              const src = $scope.cur_question.scale.more_info_column_widths;
              const newArr = new Array(count);
              for (let i = 0; i < count; i++) {
                newArr[i] = Object.prototype.hasOwnProperty.call(src, i) ? src[i] : null;
              }
              $scope.cur_question.scale.more_info_column_widths = newArr;
            }
            portalHelper.initRationaleMinChars($scope.cur_question.scale);

            initiate_scale($scope);
          }
        );
      } else {
        initiate_scale($scope);
      }
    };

  }]);
